export default Object.freeze({
    SOLTERA: 'SOLTERA',
    CASADA: 'CASADA',
    DIVORCIADA: 'DIVORCIADA',
    UNION_LIBRE: 'UNION LIBRE',
    VIUDA: 'VIUDA'
})
